import getHealthAlive from './getHealthAlive';
import getCrossTenantSessionInfo from './auth/getCrossTenantSessionInfo';
import postCrossTenantSession from './auth/postCrossTenantSession';
import getClientGeneral from './clients/getClientGeneral';
import patchClientGeneralBySid from './clients/patchClientGeneralBySid';
import getClientContentEngine from './clients/getClientContentEngine';
import getClientProviderConfig from './clients/getClientProviderConfig';
import patchClientProviderConfigBySid from './clients/patchClientProviderConfigBySid';
import deleteRiskCaches from './risks/deleteRiskCaches';
import patchClientContentEngineBySid from './clients/patchClientContentEngineBySid';
import getClientStudentManagement from './clients/getClientStudentManagement';
import getClientExcursionManagement from './clients/getClientExcursionManagement';
import getClientExcursionManagementVendorsList from './clients/getClientExcursionManagementVendorsList';
import getStudentManagementVendorList from './clients/getStudentManagementVendorList';
import getClientStudentGroupsManagement from './clients/getClientStudentGroupsManagement';
import getClientStudentGroups from './clients/getClientStudentGroups';
import getClientVendorStudentGroups from './clients/getClientVendorStudentGroups';
import getClientStudentManagementGrouping from './clients/getClientStudentManagementGrouping';
import getClientStudentManagementConfig from './clients/getClientStudentManagementConfig';
import patchClientStudentManagementConfig from './clients/patchClientStudentManagementConfig';
import patchClientStudentManagementGrouping from './clients/patchClientStudentManagementGrouping';
import postClientStudentManagementGroupingCsvToJson from './clients/postClientStudentManagementGroupingCsvToJson';
import getClientStudentList from './clients/getClientStudentList';
import getClientBySid from './clients/getClientBySid';
import patchClientExcursionManagementBySid from './clients/patchClientExcursionManagementBySid';
import getExcursionTypes from './clients/getExcursionTypes';
import getExcursionRiskCategories from './excursions/getExcursionRiskCategories';
import getAhaJwt from './ahaFeedback/getAhaJwt';
import getNewClientSecretKey from './clients/getNewClientSecretKey';
import getExcursionConfig from './excursions/getExcursionConfig';
import patchExcursionStudentsSelection from './excursions/patchExcursionStudentsSelection';
import getExcursionMedicalConditions from './excursions/getExcursionMedicalConditions';
import deleteUserInfoCache from './users/deleteUserInfoCache';
import logoutUser from './users/logoutUser';
import logoutLegacyIdpUser from './users/logoutLegacyIdpUser';
import postHubCsvUpload from './hub/postCsvUpload';
import patchClientMaintenanceModeBySid from './clients/patchClientMaintenanceModeBySid';
import getHubCsvUsers from './hub/getCsvUsers';
import getHubCsvTenants from './hub/getCsvTenants';
import getHubCsvExternalIdpSaml from './hub/getCsvExternalIdpSaml';
import getHubCsvList from './hub/getCsvList';
import getCsvZipHubUploadBatchList from './hub/getCsvZipHubUploadBatchList';
import postCsvZipHubUpload from './hub/postCsvZipHubUpload';
import patchCsvZipHubUpload from './hub/patchCsvZipHubUpload';
import getHubCsvZip from './hub/getCsvZip';
import putHubCsvZip from './hub/putCsvZip';
import getClientHubConfig from './hub/getClientHubConfig';
import postAuthInfoUpload from './hub/postAuthInfoUpload';
import getHubTenantsList from './hub/getHubTenantsList';
import getHubTenantHubConfig from './hub/getHubTenantHubConfig';
import postHubCsvTenants from './hub/postCsvTenants';
import postHubCsvUsers from './hub/postCsvUsers';
import postHubCsvExternalIdpSaml from './hub/postCsvExternalIdpSaml';
import postClientHubConfig from './hub/postClientHubConfig';
import deleteClientHubConfig from './hub/deleteClientHubConfig';
import postHubCsvExternalIdpOidc from './hub/postCsvExternalIdpOidc';
import getHubCsvExternalIdpOidc from './hub/getCsvExternalIdpOidc';
import postHubCsvProductInstances from './hub/postCsvProductInstances';
import getHubCsvProductInstances from './hub/getCsvProductInstances';
import patchCsvZipHubUploadBatchStatus from './hub/patchCsvZipHubUploadBatchStatus';

export default (axios, baseUrl) => {
  return {
    getHealthAlive: () => getHealthAlive(axios, baseUrl),
    getCrossTenantSessionInfo: getCrossTenantSessionInfo(axios, baseUrl),
    postCrossTenantSession: postCrossTenantSession(axios, baseUrl),
    getClientGeneral: getClientGeneral(axios, baseUrl),
    patchClientGeneralBySid: patchClientGeneralBySid(axios, baseUrl),
    getClientContentEngine: getClientContentEngine(axios, baseUrl),
    deleteRiskCaches: deleteRiskCaches(axios, baseUrl),
    patchClientContentEngineBySid: patchClientContentEngineBySid(axios, baseUrl),
    getClientProviderConfig: getClientProviderConfig(axios, baseUrl),
    patchClientProviderConfigBySid: patchClientProviderConfigBySid(axios, baseUrl),
    getClientStudentManagement: getClientStudentManagement(axios, baseUrl),
    getClientExcursionManagement: getClientExcursionManagement(axios, baseUrl),
    getClientExcursionManagementVendorsList: getClientExcursionManagementVendorsList(
      axios,
      baseUrl
    ),
    getStudentManagementVendorList: getStudentManagementVendorList(axios, baseUrl),
    getClientStudentGroupsManagement: getClientStudentGroupsManagement(axios, baseUrl),
    getClientStudentGroups: getClientStudentGroups(axios, baseUrl),
    getClientVendorStudentGroups: getClientVendorStudentGroups(axios, baseUrl),
    getClientStudentManagementGrouping: getClientStudentManagementGrouping(axios, baseUrl),
    getClientStudentManagementConfig: getClientStudentManagementConfig(axios, baseUrl),
    patchClientStudentManagementConfig: patchClientStudentManagementConfig(axios, baseUrl),
    patchClientStudentManagementGrouping: patchClientStudentManagementGrouping(axios, baseUrl),
    postClientStudentManagementGroupingCsvToJson: postClientStudentManagementGroupingCsvToJson(
      axios,
      baseUrl
    ),
    getClientStudentList: getClientStudentList(axios, baseUrl),
    getClientBySid: getClientBySid(axios, baseUrl),
    patchClientExcursionManagementBySid: patchClientExcursionManagementBySid(axios, baseUrl),
    getExcursionTypes: getExcursionTypes(axios, baseUrl),
    getExcursionRiskCategories: getExcursionRiskCategories(axios, baseUrl),
    getExcursionConfig: getExcursionConfig(axios, baseUrl),
    patchExcursionStudentsSelection: patchExcursionStudentsSelection(axios, baseUrl),
    getExcursionMedicalConditions: getExcursionMedicalConditions(axios, baseUrl),
    getAhaJwt: getAhaJwt(axios, baseUrl),
    getNewClientSecretKey: getNewClientSecretKey(axios, baseUrl),
    deleteUserInfoCache: deleteUserInfoCache(axios, baseUrl),
    logoutUser: logoutUser(axios, baseUrl),
    logoutLegacyIdpUser: logoutLegacyIdpUser(axios, baseUrl),
    postHubCsvUpload: postHubCsvUpload(axios, baseUrl),
    getHubCsvUsers: getHubCsvUsers(axios, baseUrl),
    getHubCsvTenants: getHubCsvTenants(axios, baseUrl),
    getHubCsvExternalIdpSaml: getHubCsvExternalIdpSaml(axios, baseUrl),
    getHubCsvList: getHubCsvList(axios, baseUrl),
    putHubCsvZip: putHubCsvZip(axios, baseUrl),
    getHubCsvZip: getHubCsvZip(axios, baseUrl),
    getCsvZipHubUploadBatchList: getCsvZipHubUploadBatchList(axios, baseUrl),
    postCsvZipHubUpload: postCsvZipHubUpload(axios, baseUrl),
    patchCsvZipHubUpload: patchCsvZipHubUpload(axios, baseUrl),
    patchClientMaintenanceModeBySid: patchClientMaintenanceModeBySid(axios, baseUrl),
    getClientHubConfig: getClientHubConfig(axios, baseUrl),
    postAuthInfoUpload: postAuthInfoUpload(axios, baseUrl),
    getHubTenantsList: getHubTenantsList(axios, baseUrl),
    getHubTenantHubConfig: getHubTenantHubConfig(axios, baseUrl),
    postHubCsvTenants: postHubCsvTenants(axios, baseUrl),
    postHubCsvUsers: postHubCsvUsers(axios, baseUrl),
    postHubCsvExternalIdpSaml: postHubCsvExternalIdpSaml(axios, baseUrl),
    postClientHubConfig: postClientHubConfig(axios, baseUrl),
    deleteClientHubConfig: deleteClientHubConfig(axios, baseUrl),
    postHubCsvExternalIdpOidc: postHubCsvExternalIdpOidc(axios, baseUrl),
    getHubCsvExternalIdpOidc: getHubCsvExternalIdpOidc(axios, baseUrl),
    postHubCsvProductInstances: postHubCsvProductInstances(axios, baseUrl),
    getHubCsvProductInstances: getHubCsvProductInstances(axios, baseUrl),
    patchCsvZipHubUploadBatchStatus: patchCsvZipHubUploadBatchStatus(axios, baseUrl)
  };
};
